import React from 'react';
import { connect } from 'react-redux';
import * as StyledCookieSettings from './cookieSettings.styles';
import {
	H2, HR, Button
} from '../base';
import Item from './item/item';
import { setCookieConfirmation } from '../../actions/cookieActions';

const CookieSettings = ({
	dispatch,
	cookieReducer
}) => {
	const approveCookies = () => {
		dispatch(setCookieConfirmation('approved'));
	};
	const { value } = cookieReducer;

	return (
		<StyledCookieSettings.Wrapper>
			<H2>Innanhús þjónustur</H2>
			<HR marginTop marginBottom />
			<StyledCookieSettings.Section>
				<StyledCookieSettings.Text>
					{`
						Við viljum að þú getir á sem bestan hátt stjórnað þeim upplýsingum
						sem safnað er um þig á þessari síðu.
						Sumar kökur gætu verið nauðsynlegar til það síðan virki á réttan hátt.
						Ef þú vilt nálgast frekari upplýsingar um þær upplýsingar sem við söfnum
						er hægt að líta á persónuverndarskilmála okkar hérna.
					`}
				</StyledCookieSettings.Text>
				{
					value === 'approved' ? (
						<StyledCookieSettings.ButtonWrapper>
							<Button secondary>Kökur samþykktar</Button>
						</StyledCookieSettings.ButtonWrapper>
					) : (
						<StyledCookieSettings.ButtonWrapper>
							<Button primary onClick={approveCookies}>Samþykkja</Button>
						</StyledCookieSettings.ButtonWrapper>
					)
				}
			</StyledCookieSettings.Section>
			<H2 marginTop="6rem">Utanaðkomandi þjónustur</H2>
			<HR marginTop marginBottom />
			<StyledCookieSettings.Section>
				<Item
					name="Google Inc"
					nameInfo="slökkva á fótsporum í gegnum þeirra vefsíðu"
					purposes="Ad Serving, Ad Targeting, Analytics/Measurement, Content Customization, Optimization"
					turnOffUrl="https://tools.google.com/dlpage/gaoptout"
					infoUrl="https://support.google.com/analytics/answer/6004245"
					learnMore="Læra meira: Google Inc" />
			</StyledCookieSettings.Section>
			<H2 marginTop="6rem">Aðrir möguleikar</H2>
			<HR marginTop marginBottom />
			<StyledCookieSettings.Section>
				<Item
					name="Slökkva á kökum í gegnum vafra"
					nameInfo=""
					purposes="Leiðbeiningar um hvernig hægt er að slökkva á kökum í gegnum vafra."
					turnOffUrl="https://www.wikihow.com/Disable-Cookies"
					infoUrl="https://www.wikihow.com/Disable-Cookies"
					learnMore="Læra meira" />
			</StyledCookieSettings.Section>
			<StyledCookieSettings.Section>
				<Item
					name="Your Online Choices"
					nameInfo=""
					purposes="Hér getur þú stjórnað þínum atferlisauglýsingum á netinu."
					turnOffUrl="http://www.youronlinechoices.com/is/"
					infoUrl="http://www.youronlinechoices.com/is/"
					learnMore="Læra meira" />
			</StyledCookieSettings.Section>
		</StyledCookieSettings.Wrapper>
	);
};

const mapStateToProps = ({ cookieReducer }) => ({
	cookieReducer
});

export default connect(mapStateToProps)(CookieSettings);
